import { render, staticRenderFns } from "./VehicleLotItemEditPage.vue?vue&type=template&id=4d7855c9&scoped=true&"
import script from "./VehicleLotItemEditPage.vue?vue&type=script&lang=js&"
export * from "./VehicleLotItemEditPage.vue?vue&type=script&lang=js&"
import style0 from "./VehicleLotItemEditPage.vue?vue&type=style&index=0&id=4d7855c9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d7855c9",
  null
  
)

export default component.exports